// mobile-scanning.interceptor.ts
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SecurityService } from 'app/core/security/security.service';
import { NotificationService } from 'app/notification.service';

@Injectable()
export class MobileScanningInterceptor implements HttpInterceptor {
  sec = inject(SecurityService);
  notificationService = inject(NotificationService);
  
  
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if user is in mobile scanning mode
    const isMobileScanningMode = this.sec.isMobileScanningMode();
    
    if (isMobileScanningMode) {
      // Only allow specific API endpoints (whitelist)
      const allowedEndpoints = [
        'api/QrLogin/ValidateToken',
        'api/MobileScanning/Scan',
        'api/sse-notif/remove',
        'api/Administration/Strich/GetStrichLicense',
        'api/online/list',
        'api/Home/GetOptions'
      ];
      
      const isAllowedEndpoint = allowedEndpoints.some(endpoint => request.url.includes(endpoint));
      
      if (!isAllowedEndpoint) {
        // For testing:
        // this.notificationService.showError(`Access denied in mobile scanning mode - url: ${request.url}`);
        
        return throwError(() => new Error('Access denied in mobile scanning mode'));
      }
    }
    
    return next.handle(request);
  }
}
